// Internal-only test-fixture inputs. These values are consumed exclusively by
// the per-chain matrix configs under ./chains/ to build *_QUERY_VECTORS. They
// are not part of the public /fixtures surface (no downstream consumer imports
// them) — keeping them here signals that and avoids confusing callers looking
// at constants/integration.ts.
// ── Test-only ethereum whales ─────────────────────────────────────────
// Addresses with real positions at the pinned block so fixtures carry
// non-empty data (instead of Vitalik-empty payloads).
/** PoolTogether's DAI prize pool — one of the largest remaining cDAI holders post-v2 deprecation. */
export const COMPOUND_V2_ETHEREUM_WHALE = "0xEBfb47A7ad0FD6e57323C8A42B2E5A6a4F68fc1a";
/** Morpho Blue borrower with active USDC/wstETH + USDC/WBTC positions at CORE_PINNED_BLOCK_HEIGHTS.ethereum. */
export const MORPHO_ETHEREUM_WHALE = "0x8eB67A509616cd6A7c1B3c8C21D48FF57df3d458";
/** Aave V3 Collector per chain (bgd-labs/aave-address-book). Guarantees a non-empty getAaveV3UserPositions fixture. */
export const AAVE_V3_COLLECTOR = {
    ethereum: "0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c",
    arbitrum: "0x053D55f9B5AF8694c503EB288a1B7E552f590710",
    base: "0xBA9424d650A4F5c80a0dA641254d1AcCE2A37057",
    optimism: "0xB2289E329D2F85F1eD31Adbb30eA345278F21bcf",
    bsc: "0x25Ec457d1778b0E5316e7f38f3c22baF413F1A8C",
    gnosis: "0x3e652E97ff339B73421f824F5b03d75b62F1Fb51",
};
// ── Canonical token / contract addresses for test fixtures ────────────
export const DAI_ETHEREUM = "0x6B175474E89094C44Da98b954EedeAC495271d0F";
/** Uniswap V3 SwapRouter on ethereum. VITALIK granted unlimited DAI allowance to it — used to exercise non-zero allowance path. */
export const UNISWAP_V3_ROUTER_ETHEREUM = "0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45";
/** BSC USDC allowance pair with non-zero allowance at CORE_PINNED_BLOCK_HEIGHTS.bsc. */
export const BSC_USDC_ALLOWANCE_OWNER = "0xbd97306a087ed0c46b783cfbfdcdc6c12c7a2866";
export const BSC_USDC_ALLOWANCE_SPENDER = "0x9be0b883c7ce55da7946ede6b8c35ccc459bab51";
/** Optimism USDC allowance pair with finite non-zero allowance at CORE_PINNED_BLOCK_HEIGHTS.optimism. */
export const OPTIMISM_USDC_ALLOWANCE_OWNER = "0xd9f7bd6033d34caf61143a460d7f79c4384aae97";
export const OPTIMISM_USDC_ALLOWANCE_SPENDER = "0x416b433906b1b72fa758e166e239c43d68dc6f29";
/** Scroll USDC allowance pair with non-zero allowance at CORE_PINNED_BLOCK_HEIGHTS.scroll. */
export const SCROLL_USDC_ALLOWANCE_OWNER = "0x4cd8d79df60e42c37650496150f744e2e53bb47c";
export const SCROLL_USDC_ALLOWANCE_SPENDER = "0x000000000022d473030f116ddee9f6b43ac78ba3";
/** X Layer USDC.e allowance pair with non-zero allowance at CORE_PINNED_BLOCK_HEIGHTS.xlayer. */
export const XLAYER_USDC_ALLOWANCE_OWNER = "0x11932ae6c9fde1e17e9fee344413c67138059adf";
export const XLAYER_USDC_ALLOWANCE_SPENDER = "0x8b773d83bc66be128c60e07e17c8901f7a64f000";
/** WMATIC — polygon's wrapped-native; used as the approve-revoke spender on polygon. */
export const WMATIC_ADDRESS = "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270";
export const BITCOIN_REFERENCE_ADDRESS = "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa";
// ── Test-helper calldata / amount ─────────────────────────────────────
/** balanceOf(VITALIK) calldata — 4-byte selector + 32-byte left-padded address. */
export const ERC20_BALANCE_OF_REFERENCE_CALLDATA = "0x70a08231000000000000000000000000d8da6bf26964af9d7eed9e03e53415d37aa96045";
/** Default swap-quote amount used across Uniswap V2/V3/V4 quote tests. */
export const SWAP_QUOTE_AMOUNT = "1.0";
// ── Per-chain pool/vault pins used to build yield vector tables ───────
export const BEEFY_VAULT = {
    ethereum: "curve-usdc-usdf",
    polygon: "morpho-compound-usdc",
    base: "aerodrome-weth-lcap",
    arbitrum: "curve-arb-asdcrv-v2.1",
    optimism: "velodrome-v2-weth-op",
    avalanche: "gmx-avax-gmx",
    bsc: "pancake-cow-bsc-eth-wbnb-vault",
};
export const MORPHO_VAULT = {
    ethereum: "0xdd0f28e19C1780eb6396170735D45153D261490d",
    base: "0xf24608E0CCb972b0b0f4A6446a0BBf58c701a026",
};
